import {
  FETCH_SHOP_OVERVIEW_REQUEST,
  FETCH_SHOP_OVERVIEW_SUCCESS,
  FETCH_SHOP_OVERVIEW_FAILURE,
} from '../actions';

const defaultShopState = {
  shop: false,
  loading: false,
  error: false
};

const reducer = (state = defaultShopState, action) => {
  switch(action.type){
    case FETCH_SHOP_OVERVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: false
      };
    case FETCH_SHOP_OVERVIEW_SUCCESS:
      return {
        ...state,
        shop: action.shop,
        loading: false,
        error: false
      };
    case FETCH_SHOP_OVERVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}

export default reducer;
